<template>
  <div class="requests-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">Patient Requests</span>
        <span class="page-subtitle" v-if="!loading">
          <i class="ft-bell"></i>
          {{ patient_requests.length }} request{{ patient_requests.length !== 1 ? 's' : '' }}
        </span>
      </div>
      <button class="refresh-btn" @click="load_requests()" title="Refresh">
        <i class="ft-refresh-cw"></i>
      </button>
    </div>

    <!-- Loading -->
    <div class="loading-state" v-if="loading">
      <div class="spinner"></div>
      <span>Loading requests…</span>
    </div>

    <!-- Empty state -->
    <div class="empty-state" v-if="!loading && patient_requests.length === 0">
      <div class="empty-icon-wrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
      </div>
      <p class="empty-title">No requests</p>
      <p class="empty-sub">There are no patient requests at the moment.</p>
      <button class="empty-refresh-btn" @click="load_requests()">
        <i class="ft-refresh-cw"></i> Refresh
      </button>
    </div>

    <!-- Request cards -->
    <div class="section-pad" v-if="!loading && patient_requests.length > 0">
      <div class="requests-grid">
        <div class="request-card" v-for="r in patient_requests" :key="r.id" :class="statusClass(r.status)">

          <!-- Card top -->
          <div class="card-top">
            <div class="patient-avatar">{{ r.patient_name ? r.patient_name.charAt(0).toUpperCase() : '?' }}</div>
            <div class="patient-info">
              <div class="patient-name">{{ r.patient_name }}</div>
              <div class="location-pills">
                <span class="loc-pill"><i class="ft-grid"></i> Bed {{ r.bed_code }}</span>
                <span class="loc-pill"><i class="ft-map-pin"></i> {{ r.ward_name }}</span>
              </div>
            </div>
            <div class="status-badge" :class="'status-badge--' + statusKey(r.status)">
              {{ statusLabel(r.status) }}
            </div>
          </div>

          <!-- Requested item -->
          <div class="request-body">
            <div class="request-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
              Request
            </div>
            <div class="request-content" v-html="r.requested_item"></div>
          </div>

          <!-- Timestamp -->
          <div class="request-time">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            {{ r.date_and_time }}
          </div>

          <!-- Actions -->
          <div class="card-actions" v-if="r.status != '14' && r.status != '5'">
            <button
              class="action-btn action-btn--accept"
              v-if="r.status != '8'"
              @click="action(r, 8)"
            >
              <i class="ft-check"></i> Accept
            </button>
            <button
              class="action-btn action-btn--complete"
              v-if="r.status == '8'"
              @click="action(r, 5)"
            >
              <i class="ft-check-circle"></i> Complete
            </button>
            <button
              class="action-btn action-btn--cancel"
              @click="action(r, 14)"
            >
              <i class="ft-x"></i> Cancel
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import swal from 'sweetalert'
import Cart from '@/components/navigation/Cart.vue'

export default {
  name: 'patientrequests',
  components: { Cart },
  data: function () {
    return {
      patient_requests: [],
      loading: true,
      free_issue: window.localStorage.getItem('free_issue'),
      cart: window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : []
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')
    this.load_requests()
  },
  methods: {
    statusKey: function (status) {
      if (status === '5')  return 'completed'
      if (status === '14') return 'cancelled'
      if (status === '8')  return 'accepted'
      return 'pending'
    },
    statusLabel: function (status) {
      if (status === '5')  return 'Completed'
      if (status === '14') return 'Cancelled'
      if (status === '8')  return 'Accepted'
      return 'Pending'
    },
    statusClass: function (status) {
      return 'request-card--' + this.statusKey(status)
    },
    load_requests: function () {
      var that = this
      var user = JSON.parse(window.localStorage.getItem('user'))
      that.loading = true

      $.ajax({
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        },
        url: this.$config.apiUrl + 'basic/medicater_hostess_requests?merchant_id=' + user.merchant.id,
        type: 'get',
        success: function (data) {
          that.loading = false
          if (data.success) {
            that.patient_requests = data.data
          } else {
            swal({ text: data.message, icon: 'info', button: 'Ok' })
          }
        },
        error: function (data) {
          that.loading = false
          swal({ text: data.responseJSON.message, icon: 'info', button: 'Ok' })
        }
      })
    },
    action: function (request, action) {
      var that = this
      var postData = { request_id: request.id, action: action }

      $.ajax({
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        },
        url: this.$config.apiUrl + '/basic/patient_request_action',
        type: 'post',
        data: JSON.stringify(postData),
        success: function () {
          that.load_requests()
        },
        error: function (data) {
          swal({ text: data.responseJSON.error, icon: 'info', button: 'Ok' })
        }
      })
    }
  }
}
</script>

<style scoped>
.requests-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0; left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn, .refresh-btn {
  width: 36px; height: 36px;
  border-radius: 10px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.2);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.95rem; cursor: pointer; flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover, .refresh-btn:hover { background: rgba(255,255,255,0.25); }

.header-info { flex: 1; display: flex; flex-direction: column; gap: 3px; }
.page-title  { font-size: 1.05rem; font-weight: 700; color: #fff; }
.page-subtitle {
  font-size: 0.73rem; color: rgba(255,255,255,0.65); font-weight: 500;
  display: flex; align-items: center; gap: 4px;
}
.page-subtitle i { font-size: 0.65rem; }

/* ── Loading ── */
.loading-state {
  display: flex; flex-direction: column; align-items: center;
  gap: 14px; padding: 120px 16px 40px;
  color: #94a3b8; font-size: 0.875rem;
}
.spinner {
  position: relative; width: 38px; height: 38px; border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #1a587b; border-left-color: #1a587b;
  animation: spin 0.9s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
}
.spinner::after {
  content: ''; position: absolute; inset: 5px; border-radius: 50%;
  border: 2.5px solid transparent;
  border-top-color: rgba(26,88,123,0.35); border-left-color: rgba(26,88,123,0.35);
  animation: spin 1.8s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite reverse;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Empty state ── */
.empty-state {
  display: flex; flex-direction: column; align-items: center;
  gap: 10px; padding: 120px 32px 40px; text-align: center;
}
.empty-icon-wrap {
  width: 72px; height: 72px; border-radius: 20px;
  background: #e0f2fe;
  display: flex; align-items: center; justify-content: center;
  color: #1a587b; margin-bottom: 4px;
}
.empty-title { font-size: 1rem; font-weight: 700; color: #0f172a; margin: 0; }
.empty-sub   { font-size: 0.85rem; color: #94a3b8; margin: 0; }
.empty-refresh-btn {
  margin-top: 6px; padding: 9px 20px; border-radius: 10px;
  background: #1a587b; color: #fff; border: none;
  font-size: 0.83rem; font-weight: 600; cursor: pointer;
  display: flex; align-items: center; gap: 7px;
  transition: opacity 0.15s;
}
.empty-refresh-btn:hover { opacity: 0.88; }

/* ── Section ── */
.section-pad {
  padding: 110px 16px 0;
  max-width: 1100px;
  margin: 0 auto;
}

/* ── Grid ── */
.requests-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}
@media (min-width: 560px)  { .requests-grid { grid-template-columns: repeat(2, 1fr); } }
@media (min-width: 900px)  { .requests-grid { grid-template-columns: repeat(3, 1fr); } }
@media (min-width: 1200px) { .requests-grid { grid-template-columns: repeat(4, 1fr); } }

/* ── Request card ── */
.request-card {
  background: #fff;
  border-radius: 16px;
  border: 1.5px solid #e8edf2;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s, transform 0.15s;
}
.request-card:hover { box-shadow: 0 6px 20px rgba(0,0,0,0.1); transform: translateY(-2px); }

.request-card--completed { border-color: #bbf7d0; }
.request-card--cancelled { border-color: #fecaca; opacity: 0.75; }
.request-card--accepted  { border-color: #bae6fd; }

/* ── Card top ── */
.card-top {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 14px 10px;
}

.patient-avatar {
  width: 38px; height: 38px; border-radius: 11px;
  background: linear-gradient(135deg, #1a587b, #0f3d5c);
  display: flex; align-items: center; justify-content: center;
  font-size: 1rem; font-weight: 700; color: #fff;
  flex-shrink: 0;
}
.request-card--completed .patient-avatar { background: linear-gradient(135deg, #16a34a, #166534); }
.request-card--cancelled .patient-avatar { background: linear-gradient(135deg, #94a3b8, #64748b); }
.request-card--accepted  .patient-avatar { background: linear-gradient(135deg, #0284c7, #0c4a6e); }

.patient-info { flex: 1; min-width: 0; }
.patient-name {
  font-size: 0.9rem; font-weight: 700; color: #0f172a;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  margin-bottom: 5px;
}

.location-pills { display: flex; flex-wrap: wrap; gap: 5px; }
.loc-pill {
  font-size: 0.66rem; font-weight: 600;
  background: #f1f5f9; color: #475569;
  padding: 2px 8px; border-radius: 999px;
  display: flex; align-items: center; gap: 3px;
}
.loc-pill i { font-size: 0.6rem; }

/* ── Status badge ── */
.status-badge {
  font-size: 0.64rem; font-weight: 800;
  padding: 3px 9px; border-radius: 999px;
  text-transform: uppercase; letter-spacing: 0.5px;
  flex-shrink: 0; white-space: nowrap;
}
.status-badge--pending   { background: #fef3c7; color: #92400e; }
.status-badge--accepted  { background: #e0f2fe; color: #0c4a6e; }
.status-badge--completed { background: #dcfce7; color: #166534; }
.status-badge--cancelled { background: #fee2e2; color: #991b1b; }

/* ── Request body ── */
.request-body {
  padding: 0 14px 10px;
  flex: 1;
}
.request-label {
  font-size: 0.67rem; font-weight: 700;
  color: #94a3b8; text-transform: uppercase; letter-spacing: 0.9px;
  display: flex; align-items: center; gap: 5px;
  margin-bottom: 5px;
}
.request-content {
  font-size: 0.875rem;
  color: #334155;
  line-height: 1.55;
}

/* ── Timestamp ── */
.request-time {
  display: flex; align-items: center; gap: 5px;
  padding: 0 14px 12px;
  font-size: 0.72rem; color: #94a3b8;
}

/* ── Actions ── */
.card-actions {
  display: flex;
  gap: 8px;
  padding: 12px 14px 14px;
  border-top: 1px solid #f1f5f9;
}

.action-btn {
  flex: 1;
  padding: 9px 10px;
  border-radius: 10px;
  border: none;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 5px;
  transition: opacity 0.15s, transform 0.1s;
}
.action-btn:hover  { opacity: 0.88; }
.action-btn:active { transform: scale(0.97); }

.action-btn--accept   { background: #1a587b; color: #fff; }
.action-btn--complete { background: #16a34a; color: #fff; }
.action-btn--cancel   { background: #fee2e2; color: #dc2626; }
</style>
